import { Heading } from "Components/Heading";
import { useDocumentTitle } from "Components/Hooks";
import { SmallIcon } from "Components/SmallIcon";
import { QuoteSavedProps } from "SharedConstants/Schema";
import { DashboardLink, HomepageLink } from "./HomepageLink";

export function QuoteSaved(props: QuoteSavedProps) {
  const title = "Quote Saved";
  useDocumentTitle(`${title} - ${props.TitleProps.PageTitleSuffix}`);
  return (
    <>
      <Heading
        {...props}
        title={`${props.IsRenewal ? "Renewal " : ""}${title}`}
      />
      <div>
        Your quote has been saved, and an e-mail with a retrieval link has been
        sent to you. Quotes are valid for {props.QuoteValidityPeriod} days after
        saving.
      </div>
      <div>
        Thanks for quoting your {props.LongProgramName} with{" "}
        {props.ProducerName}!
      </div>
      {props.IsAuthenticated && <DashboardLink />}
      <div style={{ marginTop: "1em" }}>
        <HomepageLink {...props.HomepageLinkProps} />
      </div>
      <div className="has-text-centered">
        <a href={props.BackUrl} className="button" style={{ marginTop: "1em" }}>
          <SmallIcon name="fa-arrow-left" />
          <span>Back to Quote</span>
        </a>
      </div>
    </>
  );
}
